export const LoyaltyArrowRightIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.125 1.25V7.375C9.125 7.86719 8.71484 8.25 8.25 8.25C7.75781 8.25 7.375 7.86719 7.375 7.375V3.38281L1.85156 8.87891C1.52344 9.23438 0.949219 9.23438 0.621094 8.87891C0.265625 8.55078 0.265625 7.97656 0.621094 7.64844L6.11719 2.125H2.125C1.63281 2.125 1.25 1.74219 1.25 1.25C1.25 0.785156 1.63281 0.375 2.125 0.375H8.25C8.71484 0.375 9.125 0.785156 9.125 1.25Z"
      fill="#3C8896"
    />
  </svg>
);

export const LoyaltyNoAppointmentIcon = () => (
  <svg
    width="32"
    height="29"
    viewBox="0 0 32 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25 0.5C8.17969 0.5 9 1.32031 9 2.25V4H16V2.25C16 1.32031 16.7656 0.5 17.75 0.5C18.6797 0.5 19.5 1.32031 19.5 2.25V4H22.125C23.5469 4 24.75 5.20312 24.75 6.625V9.25H0.25V6.625C0.25 5.20312 1.39844 4 2.875 4H5.5V2.25C5.5 1.32031 6.26562 0.5 7.25 0.5ZM14.25 20.625C14.25 23.9062 15.8359 26.8047 18.2969 28.5H2.875C1.39844 28.5 0.25 27.3516 0.25 25.875V11H23V11.0547C18.0781 11.4922 14.25 15.6484 14.25 20.625ZM31.75 20.625C31.75 23.4688 30.2188 26.0391 27.8125 27.4609C25.3516 28.8828 22.3438 28.8828 19.9375 27.4609C17.4766 26.0391 16 23.4688 16 20.625C16 17.8359 17.4766 15.2656 19.9375 13.8438C22.3438 12.4219 25.3516 12.4219 27.8125 13.8438C30.2188 15.2656 31.75 17.8359 31.75 20.625ZM28.25 20.625C28.25 20.1875 27.8125 19.75 27.375 19.75H20.375C19.8828 19.75 19.5 20.1875 19.5 20.625C19.5 21.1172 19.8828 21.5 20.375 21.5H27.375C27.8125 21.5 28.25 21.1172 28.25 20.625Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const LoyaltySuringeIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0586 0.941406L13.9336 1.81641L14.8086 2.69141C15.0547 2.96484 15.0547 3.375 14.8086 3.62109C14.5352 3.89453 14.125 3.89453 13.8789 3.62109L13.4688 3.21094L12.4023 4.25L13.9062 5.75391C14.1797 6.02734 14.1797 6.4375 13.9062 6.68359C13.6602 6.95703 13.25 6.95703 13.0039 6.68359L11.0352 4.71484L9.06641 2.74609C8.79297 2.5 8.79297 2.08984 9.06641 1.84375C9.3125 1.57031 9.72266 1.57031 9.96875 1.84375L11.4727 3.34766L12.5391 2.28125L12.1289 1.87109C11.8555 1.625 11.8555 1.21484 12.1289 0.96875C12.375 0.695312 12.7852 0.695312 13.0312 0.96875L13.0586 0.941406ZM6.74219 5.01562L8.41016 3.34766L8.4375 3.375L8.875 3.8125L10.4062 5.34375L11.9375 6.875L12.375 7.3125L12.4023 7.33984L7.17969 12.5625C6.87891 12.8633 6.49609 13 6.08594 13H3.65234L2.12109 14.5586C1.84766 14.832 1.4375 14.832 1.19141 14.5586C0.917969 14.3125 0.917969 13.9023 1.19141 13.6562L2.75 12.0977V9.66406C2.75 9.25391 2.91406 8.87109 3.1875 8.57031L4.36328 7.39453L5.92188 8.95312C6.11328 9.11719 6.38672 9.11719 6.55078 8.95312C6.71484 8.78906 6.71484 8.48828 6.55078 8.32422L4.99219 6.76562L6.11328 5.64453L7.67188 7.20312C7.86328 7.36719 8.13672 7.36719 8.30078 7.20312C8.46484 7.03906 8.46484 6.73828 8.30078 6.57422L6.74219 5.01562Z"
      fill="#3C8896"
    />
  </svg>
);

export const LoyaltyCartIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.40625C0 1.05078 0.273438 0.75 0.65625 0.75H1.88672C2.48828 0.75 3.03516 1.10547 3.28125 1.625H14.5195C15.2305 1.625 15.75 2.30859 15.5586 3.01953L14.4375 7.17578C14.2188 8.05078 13.4258 8.625 12.5508 8.625H4.64844L4.8125 9.41797C4.86719 9.71875 5.14062 9.9375 5.44141 9.9375H13.3438C13.6992 9.9375 14 10.2383 14 10.5938C14 10.9766 13.6992 11.25 13.3438 11.25H5.44141C4.51172 11.25 3.69141 10.5938 3.52734 9.66406L2.10547 2.25391C2.07812 2.14453 1.99609 2.0625 1.88672 2.0625H0.65625C0.273438 2.0625 0 1.78906 0 1.40625ZM3.5 13.4375C3.5 12.9727 3.74609 12.5625 4.15625 12.3164C4.53906 12.0703 5.05859 12.0703 5.46875 12.3164C5.85156 12.5625 6.125 12.9727 6.125 13.4375C6.125 13.9297 5.85156 14.3398 5.46875 14.5859C5.05859 14.832 4.53906 14.832 4.15625 14.5859C3.74609 14.3398 3.5 13.9297 3.5 13.4375ZM12.6875 12.125C13.1523 12.125 13.5625 12.3984 13.8086 12.7812C14.0547 13.1914 14.0547 13.7109 13.8086 14.0938C13.5625 14.5039 13.1523 14.75 12.6875 14.75C12.1953 14.75 11.7852 14.5039 11.5391 14.0938C11.293 13.7109 11.293 13.1914 11.5391 12.7812C11.7852 12.3984 12.1953 12.125 12.6875 12.125Z"
      fill="#3C8896"
    />
  </svg>
);

export const LoyaltyPresentIcon = ({ width = 14, height = 15 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.19531 2.63672C5.00391 2.28125 4.62109 2.0625 4.21094 2.0625H4.15625C3.52734 2.0625 3.0625 2.55469 3.0625 3.15625C3.0625 3.78516 3.52734 4.25 4.15625 4.25H6.125H6.15234L5.19531 2.63672ZM1.75 3.15625C1.75 1.84375 2.81641 0.75 4.15625 0.75H4.21094C5.08594 0.75 5.87891 1.21484 6.31641 1.98047L7 3.10156L7.65625 1.98047C8.09375 1.21484 8.88672 0.75 9.76172 0.75H9.84375C11.1562 0.75 12.25 1.84375 12.25 3.15625C12.25 3.56641 12.1406 3.92188 11.9766 4.25H13.125C13.5898 4.25 14 4.66016 14 5.125V6.875C14 7.36719 13.5898 7.75 13.125 7.75H0.875C0.382812 7.75 0 7.36719 0 6.875V5.125C0 4.66016 0.382812 4.25 0.875 4.25H1.99609C1.83203 3.92188 1.75 3.56641 1.75 3.15625ZM10.9375 3.15625C10.9375 2.55469 10.4453 2.0625 9.84375 2.0625H9.76172C9.35156 2.0625 8.99609 2.28125 8.77734 2.63672L7.82031 4.25H7.875H9.84375C10.4453 4.25 10.9375 3.78516 10.9375 3.15625ZM0.875 8.625H6.125V14.75H2.1875C1.44922 14.75 0.875 14.1758 0.875 13.4375V8.625ZM7.875 14.75V8.625H13.125V13.4375C13.125 14.1758 12.5234 14.75 11.8125 14.75H7.875Z"
      fill="#3C8896"
    />
  </svg>
);

export const LoyaltyPeopleIcon = () => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.9375 5.125C3.14453 5.125 2.43359 4.71484 2.02344 4.03125C1.64062 3.375 1.64062 2.52734 2.02344 1.84375C2.43359 1.1875 3.14453 0.75 3.9375 0.75C4.70312 0.75 5.41406 1.1875 5.82422 1.84375C6.20703 2.52734 6.20703 3.375 5.82422 4.03125C5.41406 4.71484 4.70312 5.125 3.9375 5.125ZM14 5.125C13.207 5.125 12.4961 4.71484 12.0859 4.03125C11.7031 3.375 11.7031 2.52734 12.0859 1.84375C12.4961 1.1875 13.207 0.75 14 0.75C14.7656 0.75 15.4766 1.1875 15.8867 1.84375C16.2695 2.52734 16.2695 3.375 15.8867 4.03125C15.4766 4.71484 14.7656 5.125 14 5.125ZM0 8.92578C0 7.3125 1.28516 6 2.89844 6H4.07422C4.51172 6 4.92188 6.10938 5.30469 6.27344C5.25 6.46484 5.25 6.68359 5.25 6.875C5.25 7.94141 5.6875 8.87109 6.42578 9.5H6.39844H0.574219C0.246094 9.5 0 9.25391 0 8.92578ZM11.0742 9.5H11.0469C11.7852 8.87109 12.25 7.94141 12.25 6.875C12.25 6.68359 12.2227 6.46484 12.1953 6.27344C12.5508 6.10938 12.9609 6 13.3984 6H14.5742C16.1875 6 17.5 7.3125 17.5 8.92578C17.5 9.25391 17.2266 9.5 16.8984 9.5H16.543C16.3516 9.00781 15.8594 8.625 15.3125 8.625H14.4375C13.8633 8.625 13.3711 9.00781 13.1797 9.5H11.0742ZM11.375 11.6875V12.5625C11.375 13.3008 11.9492 13.875 12.6875 13.875H13.125V14.3125C13.125 14.4766 13.125 14.6133 13.1797 14.75H4.21094C3.80078 14.75 3.5 14.4219 3.5 14.0391C3.5 12.0156 5.11328 10.375 7.13672 10.375H10.3359C10.8828 10.375 11.375 10.5117 11.8125 10.7031C11.5391 10.9492 11.375 11.3047 11.375 11.6875ZM11.375 6.875C11.375 7.83203 10.8555 8.67969 10.0625 9.17188C9.24219 9.63672 8.23047 9.63672 7.4375 9.17188C6.61719 8.67969 6.125 7.83203 6.125 6.875C6.125 5.94531 6.61719 5.09766 7.4375 4.60547C8.23047 4.14062 9.24219 4.14062 10.0625 4.60547C10.8555 5.09766 11.375 5.94531 11.375 6.875ZM14 9.9375C14 9.71875 14.1914 9.5 14.4375 9.5H15.3125C15.5312 9.5 15.75 9.71875 15.75 9.9375V11.25H17.0625C17.2812 11.25 17.5 11.4688 17.5 11.6875V12.5625C17.5 12.8086 17.2812 13 17.0625 13H15.75V14.3125C15.75 14.5586 15.5312 14.75 15.3125 14.75H14.4375C14.1914 14.75 14 14.5586 14 14.3125V13H12.6875C12.4414 13 12.25 12.8086 12.25 12.5625V11.6875C12.25 11.4688 12.4414 11.25 12.6875 11.25H14V9.9375Z"
      fill="#3C8896"
    />
  </svg>
);

export const LoyaltyHomeIcon = () => (
  <svg
    width="22"
    height="19"
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0898 9.25C21.0898 9.88281 20.5625 10.375 19.9648 10.375H18.8398L18.875 16C18.875 16.1055 18.875 16.2109 18.875 16.2812V16.8438C18.875 17.6523 18.2422 18.25 17.4688 18.25H16.9062C16.8359 18.25 16.8008 18.25 16.7656 18.25C16.7305 18.25 16.6602 18.25 16.625 18.25H15.5H14.6562C13.8477 18.25 13.25 17.6523 13.25 16.8438V16V13.75C13.25 13.1523 12.7227 12.625 12.125 12.625H9.875C9.24219 12.625 8.75 13.1523 8.75 13.75V16V16.8438C8.75 17.6523 8.11719 18.25 7.34375 18.25H6.5H5.375C5.30469 18.25 5.26953 18.25 5.19922 18.25C5.16406 18.25 5.12891 18.25 5.09375 18.25H4.53125C3.72266 18.25 3.125 17.6523 3.125 16.8438V12.9062C3.125 12.9062 3.125 12.8711 3.125 12.8359V10.375H2C1.36719 10.375 0.875 9.88281 0.875 9.25C0.875 8.93359 0.980469 8.65234 1.22656 8.40625L10.2266 0.53125C10.4727 0.285156 10.7539 0.25 11 0.25C11.2461 0.25 11.5273 0.320312 11.7383 0.496094L20.7031 8.40625C20.9844 8.65234 21.125 8.93359 21.0898 9.25Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const LoyaltyCalendarIcon = () => (
  <svg
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.625 0.25C5.22266 0.25 5.75 0.777344 5.75 1.375V2.5H10.25V1.375C10.25 0.777344 10.7422 0.25 11.375 0.25C11.9727 0.25 12.5 0.777344 12.5 1.375V2.5H14.1875C15.1016 2.5 15.875 3.27344 15.875 4.1875V5.875H0.125V4.1875C0.125 3.27344 0.863281 2.5 1.8125 2.5H3.5V1.375C3.5 0.777344 3.99219 0.25 4.625 0.25ZM0.125 7H15.875V16.5625C15.875 17.5117 15.1016 18.25 14.1875 18.25H1.8125C0.863281 18.25 0.125 17.5117 0.125 16.5625V7ZM2.375 9.8125V10.9375C2.375 11.2539 2.62109 11.5 2.9375 11.5H4.0625C4.34375 11.5 4.625 11.2539 4.625 10.9375V9.8125C4.625 9.53125 4.34375 9.25 4.0625 9.25H2.9375C2.62109 9.25 2.375 9.53125 2.375 9.8125ZM6.875 9.8125V10.9375C6.875 11.2539 7.12109 11.5 7.4375 11.5H8.5625C8.84375 11.5 9.125 11.2539 9.125 10.9375V9.8125C9.125 9.53125 8.84375 9.25 8.5625 9.25H7.4375C7.12109 9.25 6.875 9.53125 6.875 9.8125ZM11.9375 9.25C11.6211 9.25 11.375 9.53125 11.375 9.8125V10.9375C11.375 11.2539 11.6211 11.5 11.9375 11.5H13.0625C13.3438 11.5 13.625 11.2539 13.625 10.9375V9.8125C13.625 9.53125 13.3438 9.25 13.0625 9.25H11.9375ZM2.375 14.3125V15.4375C2.375 15.7539 2.62109 16 2.9375 16H4.0625C4.34375 16 4.625 15.7539 4.625 15.4375V14.3125C4.625 14.0312 4.34375 13.75 4.0625 13.75H2.9375C2.62109 13.75 2.375 14.0312 2.375 14.3125ZM7.4375 13.75C7.12109 13.75 6.875 14.0312 6.875 14.3125V15.4375C6.875 15.7539 7.12109 16 7.4375 16H8.5625C8.84375 16 9.125 15.7539 9.125 15.4375V14.3125C9.125 14.0312 8.84375 13.75 8.5625 13.75H7.4375ZM11.375 14.3125V15.4375C11.375 15.7539 11.6211 16 11.9375 16H13.0625C13.3438 16 13.625 15.7539 13.625 15.4375V14.3125C13.625 14.0312 13.3438 13.75 13.0625 13.75H11.9375C11.6211 13.75 11.375 14.0312 11.375 14.3125Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const LoyaltyRecordsIcon = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.125 0.375H16.875C17.4727 0.375 18 0.902344 18 1.5V2.625C18 3.25781 17.4727 3.75 16.875 3.75H1.125C0.492188 3.75 0 3.25781 0 2.625V1.5C0 0.902344 0.492188 0.375 1.125 0.375ZM1.125 4.875H16.875V13.875C16.875 15.1406 15.8555 16.125 14.625 16.125H3.375C2.10938 16.125 1.125 15.1406 1.125 13.875V4.875ZM5.625 7.6875C5.625 8.00391 5.87109 8.25 6.1875 8.25H11.8125C12.0938 8.25 12.375 8.00391 12.375 7.6875C12.375 7.40625 12.0938 7.125 11.8125 7.125H6.1875C5.87109 7.125 5.625 7.40625 5.625 7.6875Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const LoyaltyProfileIcon = () => (
  <svg
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 9.25C6.38281 9.25 4.90625 8.40625 4.09766 7C3.28906 5.62891 3.28906 3.90625 4.09766 2.5C4.90625 1.12891 6.38281 0.25 8 0.25C9.58203 0.25 11.0586 1.12891 11.8672 2.5C12.6758 3.90625 12.6758 5.62891 11.8672 7C11.0586 8.40625 9.58203 9.25 8 9.25ZM6.38281 10.9375H9.58203C13.0625 10.9375 15.875 13.75 15.875 17.2305C15.875 17.793 15.3828 18.25 14.8203 18.25H1.14453C0.582031 18.25 0.125 17.793 0.125 17.2305C0.125 13.75 2.90234 10.9375 6.38281 10.9375Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const LoyaltyClockIcon = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0.5C9.13281 0.5 11.1016 1.64844 12.1797 3.5C13.2578 5.375 13.2578 7.64844 12.1797 9.5C11.1016 11.375 9.13281 12.5 7 12.5C4.84375 12.5 2.875 11.375 1.79688 9.5C0.71875 7.64844 0.71875 5.375 1.79688 3.5C2.875 1.64844 4.84375 0.5 7 0.5ZM6.4375 3.3125V6.5C6.4375 6.6875 6.53125 6.875 6.67188 6.96875L8.92188 8.46875C9.17969 8.65625 9.53125 8.58594 9.71875 8.32812C9.88281 8.07031 9.8125 7.71875 9.55469 7.53125L7.5625 6.21875V3.3125C7.5625 3.00781 7.30469 2.75 7 2.75C6.67188 2.75 6.4375 3.00781 6.4375 3.3125Z"
      fill="currentColor"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3086 5.64844L16.6719 9.01172C16.8633 9.20312 17 9.47656 17 9.75C17 10.0508 16.8633 10.3242 16.6719 10.5156L13.3086 13.8789C13.1445 14.043 12.8984 14.125 12.6523 14.125C12.1602 14.125 11.75 13.7148 11.75 13.2227V11.5H8.25C7.75781 11.5 7.375 11.1172 7.375 10.625V8.875C7.375 8.41016 7.75781 8 8.25 8H11.75V6.30469C11.75 5.8125 12.1602 5.375 12.6523 5.375C12.8984 5.375 13.1445 5.48438 13.3086 5.64844ZM7.375 5.375H5.625C5.13281 5.375 4.75 5.78516 4.75 6.25V13.25C4.75 13.7422 5.13281 14.125 5.625 14.125H7.375C7.83984 14.125 8.25 14.5352 8.25 15C8.25 15.4922 7.83984 15.875 7.375 15.875H5.625C4.17578 15.875 3 14.6992 3 13.25V6.25C3 4.80078 4.17578 3.625 5.625 3.625H7.375C7.83984 3.625 8.25 4.03516 8.25 4.5C8.25 4.99219 7.83984 5.375 7.375 5.375Z"
      fill="#3A475F"
    />
  </svg>
);

export const LoyaltyIdCard = () => (
  <svg
    width="45"
    height="35"
    viewBox="0 0 45 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 5C0 2.26562 2.1875 0 5 0H40C42.7344 0 45 2.26562 45 5H0ZM0 7.5H45V30C45 32.8125 42.7344 35 40 35H5C2.1875 35 0 32.8125 0 30V7.5ZM5 29.2188C5 29.6875 5.3125 30 5.78125 30H21.6406C22.1094 30 22.5 29.6875 22.5 29.2188C22.5 26.875 20.625 25 18.2812 25H9.14062C6.79688 25 5 26.875 5 29.2188ZM13.75 12.5C11.9531 12.5 10.3125 13.5156 9.375 15C8.51562 16.5625 8.51562 18.5156 9.375 20C10.3125 21.5625 11.9531 22.5 13.75 22.5C15.4688 22.5 17.1094 21.5625 18.0469 20C18.9062 18.5156 18.9062 16.5625 18.0469 15C17.1094 13.5156 15.4688 12.5 13.75 12.5ZM27.5 13.75C27.5 14.4531 28.0469 15 28.75 15H38.75C39.375 15 40 14.4531 40 13.75C40 13.125 39.375 12.5 38.75 12.5H28.75C28.0469 12.5 27.5 13.125 27.5 13.75ZM27.5 18.75C27.5 19.4531 28.0469 20 28.75 20H38.75C39.375 20 40 19.4531 40 18.75C40 18.125 39.375 17.5 38.75 17.5H28.75C28.0469 17.5 27.5 18.125 27.5 18.75ZM27.5 23.75C27.5 24.4531 28.0469 25 28.75 25H38.75C39.375 25 40 24.4531 40 23.75C40 23.125 39.375 22.5 38.75 22.5H28.75C28.0469 22.5 27.5 23.125 27.5 23.75Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const LoyaltyLevelIcon = ({ width = 31, height = 41 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 31 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6719 0.546875C14.5312 0 15.7031 0 16.5625 0.546875L17.9688 1.48438C18.4375 1.79688 18.9844 1.875 19.5312 1.875L21.1719 1.79688C22.1875 1.71875 23.2031 2.26562 23.5938 3.20312L24.375 4.6875C24.6094 5.15625 25 5.625 25.5469 5.85938L27.0312 6.5625C27.9688 7.03125 28.5156 8.04688 28.4375 9.0625L28.3594 10.7031C28.3594 11.25 28.4375 11.7969 28.75 12.2656L29.6875 13.6719C30.2344 14.5312 30.2344 15.7031 29.6875 16.5625L28.75 17.8906C28.4375 18.3594 28.3594 18.9062 28.3594 19.5312L28.4375 21.1719C28.5156 22.1875 27.9688 23.125 27.0312 23.5938L25.5469 24.375C25.0781 24.6094 24.6094 25 24.375 25.5469L23.6719 27.0312C23.2031 27.9688 22.1875 28.5156 21.1719 28.4375L19.5312 28.3594C18.9844 28.2812 18.4375 28.4375 17.9688 28.75L16.5625 29.6875C15.7031 30.2344 14.5312 30.2344 13.6719 29.6875L12.3438 28.75C11.875 28.4375 11.3281 28.2812 10.7031 28.3594L9.0625 28.4375C8.04688 28.5156 7.10938 27.9688 6.64062 27.0312L5.85938 25.5469C5.625 25 5.23438 24.6094 4.6875 24.375L3.20312 23.5938C2.26562 23.2031 1.71875 22.1875 1.79688 21.1719L1.875 19.5312C1.95312 18.9844 1.79688 18.3594 1.48438 17.9688L0.546875 16.5625C0 15.7031 0 14.5312 0.546875 13.6719L1.48438 12.2656C1.79688 11.7969 1.95312 11.25 1.875 10.7031L1.79688 9.0625C1.71875 8.04688 2.26562 7.03125 3.20312 6.64062L4.6875 5.85938C5.23438 5.625 5.625 5.15625 5.85938 4.6875L6.64062 3.20312C7.03125 2.26562 8.04688 1.71875 9.0625 1.79688L10.7031 1.875C11.25 1.875 11.875 1.79688 12.2656 1.48438L13.6719 0.546875ZM21.4062 15.0781C21.4062 12.8906 20.1562 10.8594 18.2812 9.6875C16.3281 8.59375 13.9062 8.59375 12.0312 9.6875C10.0781 10.8594 8.90625 12.8906 8.90625 15.0781C8.90625 17.3438 10.0781 19.375 12.0312 20.5469C13.9062 21.6406 16.3281 21.6406 18.2812 20.5469C20.1562 19.375 21.4062 17.3438 21.4062 15.0781ZM0.234375 34.6094L3.59375 26.6406L4.375 28.125C5.3125 29.9219 7.1875 31.0938 9.21875 30.9375L10.8594 30.8594H10.9375L12.3438 31.7969C12.7344 32.0312 13.125 32.2656 13.5938 32.3438L10.625 39.375C10.4688 39.7656 10.0781 40.0781 9.60938 40.0781C9.14062 40.1562 8.67188 39.9219 8.4375 39.5312L5.9375 35.7031L1.5625 36.3281C1.09375 36.4062 0.625 36.25 0.390625 35.8594C0.078125 35.5469 0.078125 35.0781 0.234375 34.6094ZM19.6094 39.375L16.6406 32.3438C17.1094 32.2656 17.5 32.0312 17.8906 31.7969L19.2969 30.8594H19.375L21.0156 30.9375C23.0469 31.0938 24.9219 29.9219 25.8594 28.125L26.6406 26.6406L30 34.6094C30.2344 35.0781 30.1562 35.5469 29.8438 35.8594C29.6094 36.25 29.1406 36.4062 28.6719 36.3281L24.2969 35.7031L21.7969 39.5312C21.5625 39.9219 21.0938 40.1562 20.625 40.0781C20.1562 40.0781 19.7656 39.7656 19.6094 39.375Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const LoyaltyAccessIcon = () => (
  <svg
    width="58"
    height="45"
    viewBox="0 0 58 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.9888 28.7477C29.9687 28.707 29.9481 28.6461 29.9481 28.6055C29.5622 28.6664 29.1763 28.6867 28.77 28.6867C28.3638 28.6867 27.9778 28.6664 27.5919 28.6055C27.5919 28.6461 27.5716 28.707 27.5513 28.7477L25.2891 34.7805H32.2512L29.9888 28.7477Z"
      fill="#B8C3D6"
    />
    <path
      d="M19.7458 23.0977L7.68604 37.1673C7.39841 37.5025 7.36063 37.9865 7.5928 38.3615C7.82498 38.7383 8.27327 38.9168 8.70369 38.8138L15.8427 37.0286L17.628 44.1676C17.7371 44.6001 18.112 44.9094 18.5563 44.9352C18.5762 44.9373 18.5941 44.9373 18.6138 44.9373C19.0342 44.9373 19.4151 44.6754 19.564 44.2787L25.6173 28.1364C23.0504 27.2932 20.9527 25.4754 19.7458 23.0977Z"
      fill="#B8C3D6"
    />
    <path
      d="M49.8553 37.1673L37.7956 23.0977C36.5886 25.4754 34.4907 27.293 31.9238 28.1364L37.9772 44.2787C38.1258 44.6754 38.5067 44.9373 38.9274 44.9373C38.9473 44.9373 38.9652 44.9373 38.9849 44.9352C39.4293 44.9094 39.8041 44.6001 39.9131 44.1676L41.6984 37.0286L48.8374 38.8138C49.264 38.917 49.7141 38.7385 49.9483 38.3615C50.1805 37.9865 50.1429 37.5027 49.8553 37.1673Z"
      fill="#B8C3D6"
    />
    <path
      d="M28.7715 10.4062C24.2824 10.4062 20.6465 14.0422 20.6465 18.5312C20.6465 19.2422 20.748 19.9328 20.9105 20.5828C21.723 23.6906 24.3027 26.0672 27.5324 26.5547C27.9387 26.6156 28.3449 26.6562 28.7715 26.6562C29.198 26.6562 29.6043 26.6156 30.0105 26.5547C33.2402 26.067 35.8402 23.6703 36.6324 20.5625C36.8152 19.9125 36.8965 19.2422 36.8965 18.5312C36.8965 14.0422 33.2605 10.4062 28.7715 10.4062ZM32.834 20.5625H30.8027V22.5938C30.8027 23.7164 29.8942 24.625 28.7715 24.625C27.6488 24.625 26.7402 23.7164 26.7402 22.5938V20.5625H24.709C23.5863 20.5625 22.6777 19.6539 22.6777 18.5312C22.6777 17.4086 23.5863 16.5 24.709 16.5H26.7402V14.4688C26.7402 13.3461 27.6488 12.4375 28.7715 12.4375C29.8942 12.4375 30.8027 13.3461 30.8027 14.4688V16.5H32.834C33.9567 16.5 34.8652 17.4086 34.8652 18.5312C34.8652 19.6539 33.9567 20.5625 32.834 20.5625Z"
      fill="#B8C3D6"
    />
    <path
      d="M57.209 4.3125V2.28125C57.209 1.15858 56.3004 0.25 55.1777 0.25H2.36523C1.24256 0.25 0.333984 1.15858 0.333984 2.28125V4.3125H57.209Z"
      fill="#B8C3D6"
    />
    <path
      d="M0.333984 6.34375V32.75C0.333984 33.8727 1.24256 34.7812 2.36523 34.7812H7.04991L18.3309 21.6391C18.5137 21.4359 18.7168 21.2531 18.9402 21.0906C18.7371 20.2781 18.6152 19.4047 18.6152 18.5312C18.6152 12.925 23.1652 8.375 28.7715 8.375C34.3777 8.375 38.9277 12.925 38.9277 18.5312C38.9277 19.4047 38.8059 20.2781 38.6027 21.0906C38.8262 21.2326 39.0293 21.4156 39.2121 21.6185L50.4782 34.7812H55.1777C56.3004 34.7812 57.209 33.8727 57.209 32.75V6.34375H0.333984ZM9.47461 18.5312H5.41211C4.85067 18.5312 4.39648 18.0771 4.39648 17.5156C4.39648 16.9542 4.85067 16.5 5.41211 16.5H9.47461C10.036 16.5 10.4902 16.9542 10.4902 17.5156C10.4902 18.0771 10.036 18.5312 9.47461 18.5312ZM11.5059 12.4375H5.41211C4.85067 12.4375 4.39648 11.9833 4.39648 11.4219C4.39648 10.8604 4.85067 10.4062 5.41211 10.4062H11.5059C12.0673 10.4062 12.5215 10.8604 12.5215 11.4219C12.5215 11.9833 12.0673 12.4375 11.5059 12.4375ZM52.1309 18.5312H48.0684C47.5069 18.5312 47.0527 18.0771 47.0527 17.5156C47.0527 16.9542 47.5069 16.5 48.0684 16.5H52.1309C52.6923 16.5 53.1465 16.9542 53.1465 17.5156C53.1465 18.0771 52.6923 18.5312 52.1309 18.5312ZM52.1309 12.4375H46.0371C45.4757 12.4375 45.0215 11.9833 45.0215 11.4219C45.0215 10.8604 45.4757 10.4062 46.0371 10.4062H52.1309C52.6923 10.4062 53.1465 10.8604 53.1465 11.4219C53.1465 11.9833 52.6923 12.4375 52.1309 12.4375Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const LoyaltyExpertIcon = () => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7784_2873)">
      <path
        d="M13.371 37.186H13.761C10.4612 34.4845 8.20045 30.5612 7.67717 26.1133C4.15911 29.6719 3.43528 34.6578 6.13781 38.7838C8.33762 37.7588 10.7889 37.186 13.371 37.186Z"
        fill="#B8C3D6"
      />
      <path
        d="M35.0957 37.1851C37.798 37.1285 40.4477 37.695 42.762 38.7829C45.4754 34.6379 44.7348 29.6371 41.1846 26.0742C40.6689 30.5374 38.4043 34.4759 35.0957 37.1851Z"
        fill="#B8C3D6"
      />
      <path
        d="M36.2578 10.5515C29.9589 -2.32508 10.8398 2.41024 11.3702 16.907C20.0153 16.7855 28.6111 14.5911 36.2578 10.5515Z"
        fill="#B8C3D6"
      />
      <path
        d="M24.428 37.1861C32.0636 37.2183 37.4681 30.5815 37.4858 23.046C37.4858 23.0462 37.4858 17.2601 37.4859 16.077C37.4859 15.4648 37.444 14.8628 37.3601 14.2734C29.3414 18.3783 20.3781 20.5996 11.3701 20.7192C11.3716 20.9847 11.3781 22.7604 11.3701 23.0702C11.177 30.5815 16.8037 37.2182 24.428 37.1861Z"
        fill="#B8C3D6"
      />
      <path
        d="M11.0296 41.1992C4.76923 42.308 0 47.7898 0 54.3638V61.9501H15.2412L5.62401 53.3909L11.0296 41.1992Z"
        fill="#B8C3D6"
      />
      <path
        d="M17.6934 40.9961L24.4401 61.9528L31.1869 40.9961H17.6934Z"
        fill="#B8C3D6"
      />
      <path
        d="M40.2457 46.5997L45.1966 45.1403C43.2685 43.1196 40.7156 41.7022 37.8516 41.1992L40.2457 46.5997Z"
        fill="#B8C3D6"
      />
      <path
        d="M33.6582 61.9531H44.0591L44.2153 56.2707L42.54 54.0938L33.6582 61.9531Z"
        fill="#B8C3D6"
      />
      <path
        d="M14.3628 43.0781L10.1816 52.5112L20.4504 61.9493C19.44 58.8171 14.3628 43.0781 14.3628 43.0781Z"
        fill="#B8C3D6"
      />
      <path
        d="M34.518 43.0781L28.4316 61.9493C28.4316 61.9493 37.703 53.4829 38.7004 52.5112L34.518 43.0781Z"
        fill="#B8C3D6"
      />
      <path
        d="M65.0007 49.516L58.339 47.5524L54.4144 41.8242C54.1198 42.2541 50.6553 47.3076 50.4885 47.5524C48.7272 48.0721 45.6174 48.9889 43.8281 49.516L48.0626 55.0193L47.8709 61.9515C49.899 61.2305 52.3842 60.3567 54.4144 59.6349L60.9567 61.9515L60.7662 55.0193L65.0007 49.516Z"
        fill="#B8C3D6"
      />
    </g>
    <defs>
      <clipPath id="clip0_7784_2873">
        <rect width="65" height="65" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LoyaltyNoProfileLevelIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <foreignObject x="-16" y="-16" width="96" height="96">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(8px)",
          clipPath: "url(#bgblur_1_7784_2616_clip_path)",
          height: "100%",
          width: "100%",
        }}
      ></div>
    </foreignObject>
    <g dataFigmabgBlurRadius="16">
      <g clipPath="url(#clip0_7784_2616)">
        <rect width="64" height="64" rx="8" fill="#D3DBE9" />
        <g filter="url(#filter1_d_7784_2616)">
          <g filter="url(#filter2_dii_7784_2616)">
            <path
              d="M28.9376 7.81762C30.8255 6.69713 33.1745 6.69713 35.0624 7.81762L43.18 12.6357L51.4114 17.2567C53.3257 18.3314 54.5002 20.3657 54.4738 22.5609L54.36 32L54.4738 41.4391C54.5002 43.6343 53.3257 45.6686 51.4114 46.7433L43.18 51.3643L35.0624 56.1824C33.1745 57.3029 30.8255 57.3029 28.9376 56.1824L20.82 51.3643L12.5886 46.7433C10.6743 45.6686 9.4998 43.6343 9.52625 41.4391L9.64 32L9.52625 22.5609C9.4998 20.3657 10.6743 18.3314 12.5886 17.2567L20.82 12.6357L28.9376 7.81762Z"
              fill="url(#paint0_linear_7784_2616)"
            />
          </g>
          <path
            d="M30.9279 17.308C31.558 16.8973 32.4173 16.8973 33.0474 17.308L34.0785 18.0118C34.4222 18.2465 34.8232 18.3051 35.2242 18.3051L36.4271 18.2465C37.1718 18.1878 37.9165 18.5984 38.2029 19.3023L38.7757 20.4168C38.9476 20.7688 39.234 21.1207 39.635 21.2967L40.7233 21.8246C41.4107 22.1765 41.8117 22.9391 41.7544 23.7016L41.6971 24.9335C41.6971 25.3441 41.7544 25.7547 41.9836 26.1066L42.6709 27.1624C43.0719 27.8077 43.0719 28.6876 42.6709 29.3328L41.9836 30.33C41.7544 30.6819 41.6971 31.0925 41.6971 31.5618L41.7544 32.7936C41.8117 33.5561 41.4107 34.26 40.7233 34.612L39.635 35.1986C39.2913 35.3745 38.9476 35.6678 38.7757 36.0784L38.2602 37.1929C37.9165 37.8968 37.1718 38.3074 36.4271 38.2488L35.2242 38.1901C34.8232 38.1314 34.4222 38.2488 34.0785 38.4834L33.0474 39.1873C32.4173 39.5979 31.558 39.5979 30.9279 39.1873L29.9541 38.4834C29.6104 38.2488 29.2094 38.1314 28.7512 38.1901L27.5482 38.2488C26.8036 38.3074 26.1162 37.8968 25.7725 37.1929L25.1996 36.0784C25.0278 35.6678 24.7414 35.3745 24.3404 35.1986L23.252 34.612C22.5646 34.3187 22.1636 33.5561 22.2209 32.7936L22.2782 31.5618C22.3355 31.1512 22.2209 30.6819 21.9918 30.3886L21.3044 29.3328C20.9034 28.6876 20.9034 27.8077 21.3044 27.1624L21.9918 26.1066C22.2209 25.7547 22.3355 25.3441 22.2782 24.9335L22.2209 23.7016C22.1636 22.9391 22.5646 22.1765 23.252 21.8833L24.3404 21.2967C24.7414 21.1207 25.0278 20.7688 25.1996 20.4168L25.7725 19.3023C26.0589 18.5984 26.8036 18.1878 27.5482 18.2465L28.7512 18.3051C29.1522 18.3051 29.6104 18.2465 29.8968 18.0118L30.9279 17.308ZM36.5989 28.2183C36.5989 26.5759 35.6824 25.0508 34.3076 24.1709C32.8756 23.3497 31.0998 23.3497 29.725 24.1709C28.2929 25.0508 27.4337 26.5759 27.4337 28.2183C27.4337 29.9194 28.2929 31.4445 29.725 32.3243C31.0998 33.1455 32.8756 33.1455 34.3076 32.3243C35.6824 31.4445 36.5989 29.9194 36.5989 28.2183ZM21.0753 42.8827L23.5384 36.8996L24.1113 38.0141C24.7986 39.3633 26.1734 40.2431 27.6628 40.1258L28.8657 40.0671H28.923L29.9541 40.771C30.2405 40.947 30.5269 41.123 30.8706 41.1816L28.6939 46.4608C28.5793 46.7541 28.2929 46.9888 27.9492 46.9888C27.6055 47.0474 27.2618 46.8714 27.09 46.5782L25.2569 43.7039L22.0491 44.1732C21.7054 44.2318 21.3617 44.1145 21.1898 43.8212C20.9607 43.5866 20.9607 43.2347 21.0753 42.8827ZM35.2814 46.4608L33.1047 41.1816C33.4484 41.123 33.7348 40.947 34.0212 40.771L35.0523 40.0671H35.1096L36.3125 40.1258C37.8019 40.2431 39.1767 39.3633 39.8641 38.0141L40.4369 36.8996L42.9001 42.8827C43.0719 43.2347 43.0146 43.5866 42.7855 43.8212C42.6137 44.1145 42.27 44.2318 41.9263 44.1732L38.7184 43.7039L36.8854 46.5782C36.7135 46.8714 36.3698 47.0474 36.0261 46.9888C35.6824 46.9888 35.396 46.7541 35.2814 46.4608Z"
            fill="#BFC8D9"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="bgblur_1_7784_2616_clip_path" transform="translate(16 16)">
        <rect width="64" height="64" rx="8" />
      </clipPath>
      <filter
        id="filter1_d_7784_2616"
        x="-2"
        y="0"
        width="68"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7784_2616"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7784_2616"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dii_7784_2616"
        x="1.25842"
        y="-1.29041"
        width="87.2026"
        height="92.3003"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="12.8597" dy="12.8597" />
        <feGaussianBlur stdDeviation="10.5633" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.905882 0 0 0 0 0.909804 0 0 0 0.38 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7784_2616"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7784_2616"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-3.67421" dy="-3.67421" />
        <feGaussianBlur stdDeviation="8.72624" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.400213 0 0 0 0 0.631606 0 0 0 0 0.677885 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_7784_2616"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="9.18552" dy="9.18552" />
        <feGaussianBlur stdDeviation="5.97059" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.77 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_7784_2616"
          result="effect3_innerShadow_7784_2616"
        />
      </filter>
      <linearGradient
        id="paint0_linear_7784_2616"
        x1="58"
        y1="32"
        x2="6"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#EDF0F6" />
      </linearGradient>
      <clipPath id="clip0_7784_2616">
        <rect width="64" height="64" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LoyaltyCoinsIcon = ({ fill = "#B8C3D6" }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2.9375C14 3.42969 13.5898 3.89453 12.9336 4.25C12.1406 4.71484 10.9648 5.01562 9.59766 5.09766C9.48828 5.07031 9.37891 5.01562 9.29688 4.96094C8.20312 4.52344 6.78125 4.25 5.25 4.25C5.00391 4.25 4.78516 4.27734 4.56641 4.27734L4.53906 4.25C3.88281 3.89453 3.5 3.42969 3.5 2.9375C3.5 1.73438 5.85156 0.75 8.75 0.75C11.6484 0.75 14 1.73438 14 2.9375ZM4.375 5.17969C4.64844 5.15234 4.94922 5.125 5.25 5.125C6.94531 5.125 8.44922 5.48047 9.40625 6C10.0898 6.35547 10.5 6.82031 10.5 7.3125C10.5 7.42188 10.4727 7.53125 10.418 7.64062C10.3086 7.99609 9.95312 8.32422 9.46094 8.625H9.43359C8.47656 9.17188 6.94531 9.5 5.25 9.5C3.60938 9.5 2.16016 9.19922 1.17578 8.70703C1.12109 8.67969 1.09375 8.65234 1.03906 8.625C0.382812 8.26953 0 7.80469 0 7.3125C0 6.38281 1.44922 5.5625 3.5 5.26172C3.77344 5.23438 4.07422 5.17969 4.375 5.17969ZM11.375 7.3125C11.375 6.73828 11.0742 6.24609 10.6914 5.86328C11.4844 5.75391 12.1953 5.5625 12.7969 5.31641C13.2344 5.125 13.6445 4.87891 14 4.60547V5.5625C14 6.10938 13.5352 6.60156 12.7969 6.95703C12.3867 7.17578 11.8945 7.33984 11.3477 7.47656C11.3477 7.42188 11.375 7.36719 11.375 7.33984V7.3125ZM10.5 9.9375C10.5 10.4297 10.0898 10.8945 9.43359 11.25C9.37891 11.2773 9.35156 11.3047 9.29688 11.332C8.3125 11.8242 6.86328 12.125 5.25 12.125C3.52734 12.125 1.99609 11.7969 1.03906 11.25C0.382812 10.8945 0 10.4297 0 9.9375V8.98047C0.328125 9.25391 0.738281 9.5 1.17578 9.69141C2.26953 10.1289 3.69141 10.375 5.25 10.375C6.78125 10.375 8.20312 10.1289 9.29688 9.69141C9.48828 9.58203 9.70703 9.5 9.89844 9.39062C10.0625 9.28125 10.2266 9.17188 10.3633 9.0625C10.418 9.03516 10.4453 9.00781 10.5 8.98047V9.0625V9.22656V9.9375ZM11.375 9.9375V9.0625V8.37891C11.8945 8.24219 12.3594 8.10547 12.7969 7.94141C13.2344 7.75 13.6445 7.50391 14 7.23047V8.1875C14 8.48828 13.8633 8.76172 13.5898 9.03516C13.125 9.5 12.3594 9.85547 11.3477 10.1016C11.3477 10.0469 11.375 9.99219 11.375 9.9375ZM5.25 13C6.78125 13 8.20312 12.7539 9.29688 12.3164C9.73438 12.125 10.1445 11.8789 10.5 11.6055V12.5625C10.5 13.793 8.14844 14.75 5.25 14.75C2.35156 14.75 0 13.793 0 12.5625V11.6055C0.328125 11.8789 0.738281 12.125 1.17578 12.3164C2.26953 12.7539 3.69141 13 5.25 13Z"
      fill={fill}
    />
  </svg>
);

export const LoyaltyCheckmarckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C9.125 0 10.125 0.65625 10.625 1.625C11.6562 1.28125 12.8438 1.53125 13.6562 2.34375C14.4688 3.15625 14.7188 4.34375 14.375 5.375C15.3438 5.875 16 6.875 16 8C16 9.15625 15.3438 10.1562 14.375 10.6562C14.7188 11.6875 14.4688 12.8438 13.6562 13.6562C12.8438 14.4688 11.6562 14.7188 10.625 14.4062C10.125 15.375 9.125 16 8 16C6.84375 16 5.84375 15.375 5.34375 14.4062C4.3125 14.7188 3.15625 14.4688 2.34375 13.6562C1.53125 12.8438 1.28125 11.6875 1.59375 10.6562C0.625 10.1562 0 9.15625 0 8C0 6.875 0.625 5.875 1.59375 5.375C1.28125 4.34375 1.53125 3.15625 2.34375 2.34375C3.15625 1.53125 4.3125 1.28125 5.34375 1.625C5.84375 0.65625 6.84375 0 8 0ZM11.5312 6.53125C11.8125 6.25 11.8125 5.78125 11.5312 5.5C11.2188 5.1875 10.75 5.1875 10.4688 5.5L7 8.96875L5.53125 7.5C5.21875 7.1875 4.75 7.1875 4.46875 7.5C4.15625 7.78125 4.15625 8.25 4.46875 8.53125L6.46875 10.5312C6.75 10.8438 7.21875 10.8438 7.53125 10.5312L11.5312 6.53125Z"
      fill="url(#paint0_linear_7784_2226)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7784_2226"
        x1="8"
        y1="-2"
        x2="8"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stopColor="#6BBAC9" />
      </linearGradient>
    </defs>
  </svg>
);

export const LoyaltyLockIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.8125 4.6875V6H9.1875V4.6875C9.1875 3.48438 8.20312 2.5 7 2.5C5.76953 2.5 4.8125 3.48438 4.8125 4.6875ZM3.0625 6V4.6875C3.0625 2.52734 4.8125 0.75 7 0.75C9.16016 0.75 10.9375 2.52734 10.9375 4.6875V6H11.375C12.332 6 13.125 6.79297 13.125 7.75V13C13.125 13.9844 12.332 14.75 11.375 14.75H2.625C1.64062 14.75 0.875 13.9844 0.875 13V7.75C0.875 6.79297 1.64062 6 2.625 6H3.0625Z"
      fill="#8F9BB7"
    />
  </svg>
);

export const LoyaltyTierIcon = ({ tier = 1, numberColor = "#4C9DAD" }) => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <foreignObject x="-16" y="-16" width="92" height="92">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(8px)",
          clipPath: "url(#bgblur_1_7794_217_clip_path)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <g dataFigmabgBlurRadius="16">
      <g clipPath="url(#clip0_7794_217)">
        <rect
          width="60"
          height="60"
          rx="8"
          fill="url(#paint0_linear_7794_217)"
        />
        <g filter="url(#filter1_d_7794_217)">
          <g filter="url(#filter2_dii_7794_217)">
            <path
              d="M26.9376 9.81763C28.8255 8.69713 31.1745 8.69713 33.0624 9.81763L39.46 13.6148L45.9473 17.2567C47.8616 18.3314 49.0361 20.3657 49.0096 22.5609L48.92 30L49.0096 37.4391C49.0361 39.6343 47.8616 41.6686 45.9473 42.7433L39.46 46.3852L33.0624 50.1824C31.1745 51.3029 28.8255 51.3029 26.9376 50.1824L20.54 46.3852L14.0527 42.7433C12.1384 41.6686 10.9639 39.6343 10.9904 37.4391L11.08 30L10.9904 22.5609C10.9639 20.3657 12.1384 18.3314 14.0527 17.2567L20.54 13.6148L26.9376 9.81763Z"
              fill="url(#paint1_linear_7794_217)"
            />
          </g>

          {/* ✅ Dynamic number */}
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="central"
            fontSize="20"
            fontWeight="bold"
            fill={numberColor}
          >
            {tier}
          </text>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="bgblur_1_7794_217_clip_path" transform="translate(16 16)">
        <rect width="60" height="60" rx="8" />
      </clipPath>
      <filter
        id="filter1_d_7794_217"
        x="-4"
        y="0"
        width="68"
        height="68"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7794_217"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7794_217"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dii_7794_217"
        x="2.72327"
        y="0.709594"
        width="80.2729"
        height="84.3003"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="12.8597" dy="12.8597" />
        <feGaussianBlur stdDeviation="10.5633" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.905882 0 0 0 0 0.909804 0 0 0 0.38 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7794_217"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7794_217"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-3.67421" dy="-3.67421" />
        <feGaussianBlur stdDeviation="8.72624" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.400213 0 0 0 0 0.631606 0 0 0 0 0.677885 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_7794_217"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="9.18552" dy="9.18552" />
        <feGaussianBlur stdDeviation="5.97059" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.77 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_7794_217"
          result="effect3_innerShadow_7794_217"
        />
      </filter>
      <linearGradient
        id="paint0_linear_7794_217"
        x1="30"
        y1="0"
        x2="30"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C9DAD" />
        <stop offset="1" stopColor="#6BBAC9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7794_217"
        x1="52"
        y1="30"
        x2="8"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#EDF0F6" />
      </linearGradient>
      <clipPath id="clip0_7794_217">
        <rect width="60" height="60" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
